import { Injectable, inject } from '@angular/core';
import { PollResponse } from '../model';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { FrejaEidAuthenticationTicket } from '../model/freja-eid-authentication-ticket';

@Injectable()
export class FrejaEidOrgService {
  private httpClient = inject(HttpClient);

  private ticket: FrejaEidAuthenticationTicket;

  public setTicket(ticket: FrejaEidAuthenticationTicket): void {
    this.ticket = ticket;
  }

  public getTicket(): FrejaEidAuthenticationTicket {
    return this.ticket;
  }

  public authenticationRequest(
    authMethodType: string,
    id: string,
    idp: string
  ): Observable<FrejaEidAuthenticationTicket> {
    const params = new HttpParams().set('authMethodType', authMethodType);

    return this.httpClient.get<FrejaEidAuthenticationTicket>(`/freja-org/${idp}/order`, {
      headers: this.getHeaders(id),
      params: params
    });
  }

  public getStatus(id: string, idp: string): Observable<PollResponse> {
    if (!this.ticket) {
      return of(null);
    }

    return this.httpClient.get<PollResponse>(`/freja-org/${idp}/poll`, {
      headers: this.getHeaders(id)
    });
  }

  public cancelAuthentication(id: string, idp: string): void {
    window.location.href = `/freja-org/${idp}/cancel?id=${id}`;
  }

  private getHeaders(id: string): HttpHeaders {
    return new HttpHeaders().set('xhr', 'true').set('id', id);
  }
}
